import { Component } from '@angular/core';
import {FormField} from "@shared/components/form/models/beans/form-field.abstract";

@Component({
  selector: 'hiddenfield',
  templateUrl: './hiddenfield.component.html',
  styleUrls: ['./hiddenfield.component.scss']
})
export class HiddenfieldComponent extends FormField {

}
